<template>
  <div class="checkbox">
    <input
      v-model="newValue"
      type="checkbox"
      class="checkbox__input"
      id="checkbox-label"
    />
    <component :is="labelTag" class="checkbox__label" for="checkbox-label">
      <slot></slot>
    </component>
  </div>
</template>

<script>
export default {
  name: "VCheckbox",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    labelTag: {
      type: String,
      default: "span"
    }
  },
  data() {
    return {
      newValue: this.value
    };
  },
  watch: {
    newValue(v) {
      this.$emit("input", v);
    },
    value(v) {
      this.newValue = v;
    }
  }
};
</script>

<style scoped lang="scss">
.checkbox {
  position: relative;
  display: flex;
  align-items: center;
  &__input {
    background: transparent;
    -webkit-appearance: none;
    position: relative;
    margin-right: 15px;
    border: 1px solid $gray-border;
    border-radius: 3px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    &:checked:before {
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      background-image: url(../assets/images/check.svg);
      background-repeat: no-repeat;
      background-size: 15px 15px;
      background-position: top center;
    }
  }
  &__label {
    cursor: pointer;
  }
}
</style>
